import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import axios from "../../utils/Axios/axiosProxy";
import { AdminDashboardContext } from "../../pages/AdminDashboard/AdminDashboard";
import AddDocument from "../../assets/Icons/add-shipper.png";
import GetAppIcon from "@material-ui/icons/GetApp";

function UploadDocument({ ...props }) {
  const [orderDocuments, setOrderDocuments] = React.useState(
    props.orderDocuments
  );
  const [documentName, setDocumentName] = React.useState("");
  const adminDashboardContext = React.useContext(AdminDashboardContext);
  useEffect(() => {
    setOrderDocuments(props.orderDocuments);
  }, [props.orderDocuments]);

  const updateOrder = (document) => {
    let data = {
      orderID: props.orderID,
      updateParams: {
        documents: document,
      },
    };
    axios
      .patch("/api/order/update", data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        adminDashboardContext.getOrdersFromDB(localStorage.getItem("JWT"));
        console.log("UPDATE ORDER RESPONSE: ", response.statusText);
      })
      .catch((error) => {
        console.log("UPDATE ORDER ERROR: ", error.response.data);
      })
      .catch((error) => console.log("submitToDB error", error));
  };
  const upload = (data, filename) => {
    let formData = new FormData();
    formData.append("pdf", data);
    formData.append("userID", props.userID);
    formData.append("filename", filename);
    formData.append("email", props.contactEmail);
    formData.append("name", props.contactName);
    formData.append("id", props.orderID);
    axios
      .post("/pdf", formData, {
        headers: {
          "Content-Type": "application/pdf",
        },
      })
      .then((response) => {
        console.log("UPLOAD FILE RESPONSE: ", response);
      })
      .catch((error) => {
        console.log("UPLOAD FILE ERROR: ", error);
      })
      .catch((error) => console.log("UPLOAD FILE CLIENT ERROR", error));
  };
  const getPDF = (filename) => {
    axios
      .get(`/pdf/${filename}.pdf`, {
        headers: {
          "Content-Type": "application/pdf",
        },
      })
      .then((response) => {
        window.open(response.data.url, "_blank");
        console.log("GET PDF RESPONSE: ", response);
      })
      .catch((error) => {
        console.log("GET PDF ERROR: ", error);
      })
      .catch((error) => console.log("GET PDF CLIENT ERROR", error));
  };

  const handleChange = async (event, documentID) => {
    let file = event.target.files[0];
    let filename = `${documentID}_${props.orderID}`;
    let updatedDocuments = { ...orderDocuments, [documentID]: filename };
    setOrderDocuments({ ...orderDocuments, [documentID]: filename });
    await upload(file, filename);
    updateOrder(updatedDocuments);
  };

  const setDocuments = () => {
    let documentsToDisplay = [];
    for (let i in orderDocuments) {
      documentsToDisplay.push(
        <Button
          className="AddShipper LightGrey Large MarginSides"
          variant="contained"
          onClick={() => {
            getPDF(orderDocuments[i]);
          }}
        >
          <span style={{ display: "inline-flex", alignItems: "center" }}>
            <GetAppIcon />
          </span>
          {`${i}`}
        </Button>
      );
    }
    return documentsToDisplay;
  };
  return (
    <>
      <div className="MarginHorizontal" style={{ minHeight: "80px" }}>
        {setDocuments()}
        <div className="Column" style={{ float: "right" }}>
          <Button
            className="AddShipper LightGrey Large MarginSides"
            variant="contained"
            component="label"
          >
            <span style={{ display: "inline-flex", alignItems: "center" }}>
              <img src={AddDocument} alt="plus-sign" />
            </span>
            {`Document`}
            <input
              type="file"
              hidden
              onChange={(event) => {
                handleChange(event, documentName);
              }}
            />
          </Button>
          <TextField
            style={{ width: "200px" }}
            className="MarginSides"
            id="documentname"
            placeholder="document name"
            variant="outlined"
            value={documentName}
            onChange={(event) => setDocumentName(event.target.value)}
          />
        </div>
      </div>
    </>
  );
}

export default UploadDocument;
